export const SET_MESSAGE = "CONFIG/SET_MESSAGE";
export const SET_ALERTS = "CONFIG/SET_ALERTS";
export const SET_PAGINATION = "CONFIG/SET_PAGINATION";
export const SET_COUNT = "CONFIG/SET_COUNT";
